<template>
  <div class="streaming-message mb-6">
    <div
      v-if="content"
      class="chat-bubble system-message"
    >
      <div
        class="message-text"
        v-html="parsedContent"
      />
    </div>
    <div class="statuses">
      <div
        v-for="(toolCall, idx) in pendingTools"
        :key="idx"
        class="status"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="16"
          width="2"
        />
        <span>{{ toolCallDescription(toolCall.name) }}...</span>
      </div>
    </div>
    <div
      v-if="!content && pendingTools.length === 0"
      class="status"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="16"
        width="2"
      />
      <span>Thinking...</span>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';

const TOOL_DESCRIPTIONS = {
  get_leaderboard: 'Analysing leaderboard',
  search_tenders: 'Searching notices',
  get_user_profile_details: 'Analysing your user profile',
  get_tender_notice: 'Analysing notice',
  get_market_insights: 'Analysing market insights',
  get_user_saved_searches: 'Analysing your saved searches',
  get_user_lists: 'Analysing your lists',
  get_user_history: 'Analysing your previous activity',
  get_pipelines_list: 'Analysing your pipelines',
  get_pipeline_details: 'Analysing pipeline',
  get_user_clusters: 'Analysing your clusters',
  get_cluster_contracts: 'Analysing cluster',
  get_pipeline_contracts: 'Analysing pipeline contracts',
  save_search: 'Saving search',
  create_pipeline: 'Creating pipeline',
  create_cluster: 'Creating cluster',
  add_entities_to_cluster: 'Adding entities to cluster',
  run_saved_search: 'Executing saved search',
  get_search_summary: 'Searching notices',
  generate_pdf_report: 'Generating PDF report',
};

export default {
  name: 'StreamingMessage',
  props: {
    content: {
      type: String,
      default: '',
    },
    pendingTools: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    parsedContent() {
      return this.content ? marked.parse(this.content) : '';
    },
  },
  methods: {
    toolCallDescription(name) {
      return TOOL_DESCRIPTIONS[name] ?? name;
    },
  },
};
</script>

<style scoped>
/* Inline critical bubble styles so background applies (external scoped CSS can fail in some builds) */
.chat-bubble {
  position: relative;
  max-width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.system-message {
  background-color: #12253a;
  color: white;
  margin-right: auto;
  margin-left: 0;
  border-radius: 18px 18px 18px 4px;
  margin-top: 14px;
}

.system-message::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-right-color: #12253a;
  border-left: 0;
  border-bottom: 0;
  margin-left: -6px;
  margin-bottom: 12px;
}

.statuses {
  margin-top: 12px;
}

.status {
  display: flex;
  gap: 6px;
  font-size: 14px;
  color: #12253a;
  align-items: center;
}
</style>
